// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteSkeleton_wrapper_S3rlU"};